module.exports = __webpack_public_path__ + "static/img/yingrenTitle.df45208.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImage/yingrenTitle.png
// module id = cyJk
// module chunks = 0